import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const UsersIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.262 9.28c.473.375.738.95.738 1.554v1.164H0v-1.164c0-.604.265-1.179.738-1.554.723-.574 1.977-1.282 3.762-1.282s3.039.708 3.762 1.282ZM7 4.498a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm4.5 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1c1.785 0 3.04.708 3.762 1.282.473.375.738.95.738 1.554v1.164h-5v-1.164c0-1-.375-1.927-1.019-2.647a6.205 6.205 0 0 1 1.52-.189Z", fill: "currentColor" })));
});
UsersIcon.displayName = 'UsersIcon';
export default UsersIcon;
